import { Result } from '@empathy/search-types';
import { deepMerge } from '@empathybroker/deep-merge';
import { SearchState } from '../../../models';
import { DeepPartial } from '../../../utils';
import { SEARCH_MUTATIONS_KEYS } from '../search.const';
import { SearchMutation } from '../search.interfaces';

export interface UpdateResultMutationPayload {
  result: Result;
  update: DeepPartial<Result>;
}

export class UpdateResultMutation implements SearchMutation {
  mutations = {
    [SEARCH_MUTATIONS_KEYS.updateResult]: (searchState: SearchState, { result, update }: UpdateResultMutationPayload) => {
      deepMerge(result, update);
    }
  };
}
